import '@assets/styles/index.scss'
import { useLocation } from 'react-router-dom'
import { ROUTES } from '@core/config/routing'
import { PolicyExpiredScreen } from '@/ui/components/PolicyExpiredScreen'
import { AppModule } from '../core/modules/app/app.module'
import { MainRouter } from './mainRouter'
import { MfaEnforcementRouter } from './mfaEnforcementRouter'

const CustomRouter = () => {
    const { shouldEnforceMfa, allPoliciesExpired } = AppModule.useStore()
    const location = useLocation()
    const isLogoutRoute = location.pathname === ROUTES.auth.children.logout.path

    if (allPoliciesExpired && !isLogoutRoute) {
        return <PolicyExpiredScreen />
    }

    if (shouldEnforceMfa) {
        return <MfaEnforcementRouter />
    }

    return <MainRouter />
}

export { CustomRouter, ROUTES }
export type TAppRouter = typeof CustomRouter
